import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetexRegulationsQueryQueryVariables = Types.Exact<{
  queryArgs: Types.QueryArgsInput;
}>;


export type GetexRegulationsQueryQuery = { __typename?: 'Query', getexRegulationsQuery: { __typename?: 'GetexRegulationsInfinityResults', getexIds: Array<string>, getexRegulationsBatch: Array<{ __typename?: 'GetexRegulation', id: string, regulationNumber: string, regulationTitle: string, regulationStatus: string, dateEffective?: any | null, keywords: Array<string>, vehicleCategories: Array<string>, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, file: { __typename?: 'BlobRef', uri: any, fileName: string, originalFileName?: string | null } }> | null }> } };

export type GetexRegulationsNextQueryVariables = Types.Exact<{
  nextArgs: Types.NextArgsInput;
}>;


export type GetexRegulationsNextQuery = { __typename?: 'Query', getexRegulationsNext: Array<{ __typename?: 'GetexRegulation', id: string, regulationNumber: string, regulationTitle: string, regulationStatus: string, dateEffective?: any | null, keywords: Array<string>, vehicleCategories: Array<string>, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, file: { __typename?: 'BlobRef', uri: any, fileName: string, originalFileName?: string | null } }> | null }> };

export type GetexSortOrdersQueryVariables = Types.Exact<{
  sortArgs: Types.SortArgsInput;
}>;


export type GetexSortOrdersQuery = { __typename?: 'Query', getexSortOrders: Array<string> };


export const GetexRegulationsQueryDocument = gql`
    query GetexRegulationsQuery($queryArgs: QueryArgsInput!) {
  getexRegulationsQuery(queryArgs: $queryArgs) {
    getexIds
    getexRegulationsBatch {
      id
      regulationNumber
      regulationTitle
      regulationStatus
      dateEffective
      keywords
      vehicleCategories
      attachments {
        attachmentId
        file {
          uri
          fileName
          originalFileName
        }
      }
    }
  }
}
    `;

/**
 * __useGetexRegulationsQueryQuery__
 *
 * To run a query within a React component, call `useGetexRegulationsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetexRegulationsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetexRegulationsQueryQuery({
 *   variables: {
 *      queryArgs: // value for 'queryArgs'
 *   },
 * });
 */
export function useGetexRegulationsQueryQuery(baseOptions: Apollo.QueryHookOptions<GetexRegulationsQueryQuery, GetexRegulationsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetexRegulationsQueryQuery, GetexRegulationsQueryQueryVariables>(GetexRegulationsQueryDocument, options);
      }
export function useGetexRegulationsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetexRegulationsQueryQuery, GetexRegulationsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetexRegulationsQueryQuery, GetexRegulationsQueryQueryVariables>(GetexRegulationsQueryDocument, options);
        }
export type GetexRegulationsQueryQueryHookResult = ReturnType<typeof useGetexRegulationsQueryQuery>;
export type GetexRegulationsQueryLazyQueryHookResult = ReturnType<typeof useGetexRegulationsQueryLazyQuery>;
export type GetexRegulationsQueryQueryResult = Apollo.QueryResult<GetexRegulationsQueryQuery, GetexRegulationsQueryQueryVariables>;
export const GetexRegulationsNextDocument = gql`
    query GetexRegulationsNext($nextArgs: NextArgsInput!) {
  getexRegulationsNext(nextArgs: $nextArgs) {
    id
    regulationNumber
    regulationTitle
    regulationStatus
    dateEffective
    keywords
    vehicleCategories
    attachments {
      attachmentId
      file {
        uri
        fileName
        originalFileName
      }
    }
  }
}
    `;

/**
 * __useGetexRegulationsNextQuery__
 *
 * To run a query within a React component, call `useGetexRegulationsNextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetexRegulationsNextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetexRegulationsNextQuery({
 *   variables: {
 *      nextArgs: // value for 'nextArgs'
 *   },
 * });
 */
export function useGetexRegulationsNextQuery(baseOptions: Apollo.QueryHookOptions<GetexRegulationsNextQuery, GetexRegulationsNextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetexRegulationsNextQuery, GetexRegulationsNextQueryVariables>(GetexRegulationsNextDocument, options);
      }
export function useGetexRegulationsNextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetexRegulationsNextQuery, GetexRegulationsNextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetexRegulationsNextQuery, GetexRegulationsNextQueryVariables>(GetexRegulationsNextDocument, options);
        }
export type GetexRegulationsNextQueryHookResult = ReturnType<typeof useGetexRegulationsNextQuery>;
export type GetexRegulationsNextLazyQueryHookResult = ReturnType<typeof useGetexRegulationsNextLazyQuery>;
export type GetexRegulationsNextQueryResult = Apollo.QueryResult<GetexRegulationsNextQuery, GetexRegulationsNextQueryVariables>;
export const GetexSortOrdersDocument = gql`
    query GetexSortOrders($sortArgs: SortArgsInput!) {
  getexSortOrders(sortArgs: $sortArgs)
}
    `;

/**
 * __useGetexSortOrdersQuery__
 *
 * To run a query within a React component, call `useGetexSortOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetexSortOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetexSortOrdersQuery({
 *   variables: {
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useGetexSortOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetexSortOrdersQuery, GetexSortOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetexSortOrdersQuery, GetexSortOrdersQueryVariables>(GetexSortOrdersDocument, options);
      }
export function useGetexSortOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetexSortOrdersQuery, GetexSortOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetexSortOrdersQuery, GetexSortOrdersQueryVariables>(GetexSortOrdersDocument, options);
        }
export type GetexSortOrdersQueryHookResult = ReturnType<typeof useGetexSortOrdersQuery>;
export type GetexSortOrdersLazyQueryHookResult = ReturnType<typeof useGetexSortOrdersLazyQuery>;
export type GetexSortOrdersQueryResult = Apollo.QueryResult<GetexSortOrdersQuery, GetexSortOrdersQueryVariables>;